import * as S from './app.styled';
import { Top } from './components/top/Top';
import { MainFuntion } from './components/main-function/MainFuntion';
import { RateBox } from './components/rate-box/RateBox';
import { FAQs } from './components/faqs/FAQs';
import { Footer } from './components/footer/Footer';
import PolicyPage from './components/policy/PolicyPage';

import { useParams, createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { LIST_LANGUAGE } from './configs/common';

const AppComponent = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const lowerLang = (lang || '').toLowerCase();

    if (lowerLang && LIST_LANGUAGE.includes(lowerLang)) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage('en');
    }
  }, [lang, i18n]);

  return (
    <S.LayoutStyled lang={lang}>
      <S.WrapperStyled>
        <Top />

        <MainFuntion />

        <RateBox />

        <FAQs />

        <Footer />
      </S.WrapperStyled>
    </S.LayoutStyled>
  );
};

const RedirectToDefaultLanguage = () => {
  return <Navigate to="/en" replace />;
};

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <RedirectToDefaultLanguage />,
    },
    {
      path: '/:lang',
      element: <AppComponent />,
    },
    {
      path: '/privacy.html',
      element: <PolicyPage />,
    },
    {
      path: '*',
      element: <div>Not Found</div>,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
